import { string, number, shape } from 'prop-types';

export const CabinetProps = {
  Sku: number.isRequired,
  Origin: shape({
    Row: number.isRequired,
    Column: number.isRequired,
    Height: number.isRequired,
    Width: number.isRequired,
  }).isRequired,
  Precedence: number.isRequired,
  ChoiceId: number,
  ChoiceBundle: string,
};

export const CabinetShape = shape(CabinetProps);

export const SegmentProps = {
  Start: shape({
    Row: number.isRequired,
    Column: number.isRequired,
    Height: number.isRequired,
  }).isRequired,
  End: shape({
    Row: number.isRequired,
    Column: number.isRequired,
    Height: number.isRequired,
  }).isRequired,
  Type: string.isRequired,
};

export const SegmentShape = shape(SegmentProps);